export default __webpack_public_path__ + "4d410e4977b3525f9fca202da60d43ed.ttf";